import React from 'react';
import { Checkbox, Stack, Text } from '@fluentui/react';
import sampleImg from '../../assets/img/shippingContainers.png';
import { SubjectImagePreferences } from '../../services';
import { numericalSpacingStackTokens } from '../admin/SettingsStyles';
import { ImageUrlType } from '../shared/content/jsonContentTypes/ImageUrlType';

interface ContentPreviewsProps {
  displayName: string;
  imageUxPreferences: SubjectImagePreferences;
  onUxPreferenceChange: (string, boolean) => void;
}

export const ContentPreviewsGeneric: React.FunctionComponent<ContentPreviewsProps> = props => {
  return (
    <Stack>
      <Text as={'h2'} variant={'xLarge'} style={{ height: 24 }} className={'my-2'}>
        {'Protect moderator wellness'}
      </Text>
      <Text variant={'mediumPlus'} style={{ width: 504 }}>
        {'Blur, desaturate, and/or flip content thumbnails to reduce impact of viewing harmful content'}
      </Text>
      <Text variant={'mediumPlus'} style={{ marginTop: 32 }}>
        {`Select the default thumbnail styles for ${props.displayName} queue cases:`}
      </Text>
      <Stack horizontal tokens={numericalSpacingStackTokens} className={'mt-3'}>
        <Stack>
          <Checkbox
            label="Blur"
            onChange={(e, isDefaultBlur) => props.onUxPreferenceChange('isDefaultBlur', isDefaultBlur)}
          />
          <Checkbox
            label="Desaturate"
            onChange={(e, isDefaultGrayscale) => props.onUxPreferenceChange('isDefaultGrayscale', isDefaultGrayscale)}
          />
          <Checkbox
            label="Flip"
            onChange={(e, isDefaultFlipped) => props.onUxPreferenceChange('isDefaultFlipped', isDefaultFlipped)}
          />
        </Stack>
        <Stack style={{ marginTop: 5, marginLeft: 47 }}>
          <ImageUrlType
            subjectImagePreferences={props.imageUxPreferences}
            value={sampleImg}
            caption={''}
            isGridView={false}
          />
        </Stack>
      </Stack>
    </Stack>
  );
};
